<div class="main">
    <ng-container *ngIf="!isCallInvoked">
        <div class="loader-body sp-middle-element">
            <div class="col-sm-12">
              <div class="loader center-block" ></div>
            </div>
        </div>
    </ng-container>
</div>